import type { Traducao } from '../tipos';

/** Sidebar, header e o que envolve toda tela autenticada. */
export const layout: Traducao = {
  pt: {
    app: {
      carregando: 'Carregando...',
      pwaAtualizacao: 'Nova versão disponível. Atualize para usar a versão mais recente.',
      pwaAtualizarAgora: 'Atualizar agora',
    },
    sidebar: {
      titulo: 'Sistema de Apreciação',
      ocultar: 'Ocultar Sidebar',
      mostrar: 'Mostrar Sidebar',
      rodape: {
        area: 'Segurança Industrial',
        normas: 'NR-12 | ISO 12100',
      },
      menu: {
        projetos: 'Projetos',
        usuarios: 'Usuários',
        feedbacks: 'Feedbacks',
        squads: 'Squads',
        estruturacao: 'Estruturação',
        vendas: 'Vendas',
        cotacoes: 'Cotações',
        carteira: 'Carteira',
        carteiraPainel: 'Painel',
        carteiraEquipe: 'Equipe e custo',
        ia: 'IA',
        budget: 'Budget',
        mesclarPdfs: 'Mesclar PDFs',
        dashboard: 'Dashboard',
        estatisticas: 'Estatísticas',
        apreciacoes: 'Apreciações',
        revisoes: 'Revisões',
        maquinas: 'Máquinas',
        aquisicaoCampo: 'Aquisição de Campo',
        imagensMaquinas: 'Imagens de Máquinas',
        templates: 'Templates',
        cronograma: 'Cronograma',
        relatorio: 'Relatório',
      },
    },
    header: {
      trocarIdioma: 'Mudar idioma (PT/EN)',
      modoClaro: 'Modo claro',
      modoEscuro: 'Modo escuro',
      notificacoes: 'Notificações',
      semNotificacoes: 'Não há novas notificações no momento.',
      build: 'Build: {{data}}',
      online: 'Online',
      offline: 'Offline',
      ultimaAtualizacao: 'Última atualização: {{data}}',
      semAtualizacao: 'Sem atualização recente',
      instalarApp: 'Instalar o app no dispositivo',
      instalar: 'Instalar',
      meuPerfil: 'Meu perfil',
      usuario: 'Usuário',
      administrador: 'Administrador',
      sair: 'Sair',
    },
    feedback: {
      instrucao: 'Clique num elemento ou arraste para selecionar uma área',
      instrucaoEsc: 'sai',
      areaSelecionada: 'Área selecionada',
      titulo: 'Comentário de correção',
      gerandoPrint: 'Gerando print...',
      printAlt: 'Print da seleção',
      semPrint: 'Sem print (falha na captura) — o comentário vai mesmo assim',
      comentarioPlaceholder: 'O que precisa ser corrigido aqui?',
      enviando: 'Enviando...',
      enviado: 'Feedback enviado!',
      erroEnviar: 'Erro ao enviar feedback',
      sairModo: 'Sair do modo feedback',
      abrirModo: 'Apontar correção na tela',
    },
    lock: {
      meuLock: 'Você está editando este recurso',
      meuLockExpira: 'Lock expira em: {{data}}',
      lockDeOutro: 'Este recurso está sendo editado por outro usuário',
      editandoPor: 'Editando:',
      expiraEm: 'Expira em: {{data}}',
      avisoBloqueio: 'Você não pode editar enquanto outro usuário estiver editando',
    },
  },
  en: {
    app: {
      carregando: 'Loading...',
      pwaAtualizacao: 'A new version is available. Update to use the latest one.',
      pwaAtualizarAgora: 'Update now',
    },
    sidebar: {
      titulo: 'Risk Assessment System',
      ocultar: 'Hide sidebar',
      mostrar: 'Show sidebar',
      rodape: {
        area: 'Industrial Safety',
        normas: 'NR-12 | ISO 12100',
      },
      menu: {
        projetos: 'Projects',
        usuarios: 'Users',
        feedbacks: 'Feedback',
        squads: 'Squads',
        estruturacao: 'Structuring',
        vendas: 'Sales',
        cotacoes: 'Quotes',
        carteira: 'Portfolio',
        carteiraPainel: 'Overview',
        carteiraEquipe: 'Team and cost',
        ia: 'AI',
        budget: 'Budget',
        mesclarPdfs: 'Merge PDFs',
        dashboard: 'Dashboard',
        estatisticas: 'Statistics',
        apreciacoes: 'Assessments',
        revisoes: 'Reviews',
        maquinas: 'Machines',
        aquisicaoCampo: 'Field Capture',
        imagensMaquinas: 'Machine Images',
        templates: 'Templates',
        cronograma: 'Schedule',
        relatorio: 'Report',
      },
    },
    header: {
      trocarIdioma: 'Change language (PT/EN)',
      modoClaro: 'Light mode',
      modoEscuro: 'Dark mode',
      notificacoes: 'Notifications',
      semNotificacoes: 'No new notifications right now.',
      build: 'Build: {{data}}',
      online: 'Online',
      offline: 'Offline',
      ultimaAtualizacao: 'Last update: {{data}}',
      semAtualizacao: 'No recent update',
      instalarApp: 'Install the app on this device',
      instalar: 'Install',
      meuPerfil: 'My profile',
      usuario: 'User',
      administrador: 'Administrator',
      sair: 'Sign out',
    },
    feedback: {
      instrucao: 'Click an element or drag to select an area',
      instrucaoEsc: 'to exit',
      areaSelecionada: 'Selected area',
      titulo: 'Correction comment',
      gerandoPrint: 'Taking screenshot...',
      printAlt: 'Screenshot of the selection',
      semPrint: 'No screenshot (capture failed) — the comment is sent anyway',
      comentarioPlaceholder: 'What needs to be fixed here?',
      enviando: 'Sending...',
      enviado: 'Feedback sent!',
      erroEnviar: 'Could not send the feedback',
      sairModo: 'Leave feedback mode',
      abrirModo: 'Point out a fix on the screen',
    },
    lock: {
      meuLock: 'You are editing this resource',
      meuLockExpira: 'Lock expires at: {{data}}',
      lockDeOutro: 'This resource is being edited by another user',
      editandoPor: 'Editing:',
      expiraEm: 'Expires at: {{data}}',
      avisoBloqueio: 'You cannot edit while another user is editing',
    },
  },
};
